import React from 'react';

import { BoxProps, Grid, Title as MantineTitle, Stack, StackProps, Text } from '@mantine/core';

import { WIDE_CONTENT_WIDTH } from 'components/page/Content';
import { Page } from 'components/page/Page';

const Hero = ({
    image,
    video,
    title,
    subtitle,
    body,
    wrapperProps,
}: {
    image?: {
        src: string;
        width: number;
        height: number;
    };
    video?: {
        src: string;
        width: number;
        height: number;
    };
    title?: string;
    subtitle?: string;
    body: React.ReactNode;
    wrapperProps?: BoxProps;
}) => {
    return (
        <Page.Hero image={image} video={video} {...wrapperProps}>
            <Title maw={600} mx="auto" mb="xl" hiddenFrom="md" title={title} subtitle={subtitle} />

            <Stack gap="xl" maw={WIDE_CONTENT_WIDTH} mx="auto">
                {body}
            </Stack>
        </Page.Hero>
    );
};

const Title = ({ title, subtitle, ...props }: { title?: string; subtitle?: string } & StackProps) => {
    if (!title && !subtitle) {
        return null;
    }

    return (
        <Stack gap="xs" align="center" justify="center" {...props}>
            {title && (
                <MantineTitle fz={32} fw={800}>
                    {title}
                </MantineTitle>
            )}
            {subtitle && (
                <Text fz={20} fw={600} opacity={0.8}>
                    {subtitle}
                </Text>
            )}
        </Stack>
    );
};

export { Hero };
